import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductRecommendationModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import prepareTrack from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import { generateGeneralPrepare } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<{ url: string }, { recommendation: ProductRecommendationModel }>;

const pageTypesToSkip: string[] = [
    "CategoryDetailsPage",
    "ProductDetailsPage",
    "ProductListPage",
    "CartPage",
    "CheckoutReviewAndSubmitPage",
    "OrderConfirmationPage",
    "MyListsDetailsPage",
];

export const ValidateContext: HandlerType = ({ getState }) => {
    const currentPageType = getCurrentPage(getState()).type;
    if (pageTypesToSkip.includes(currentPageType)) {
        return false;
    }
};

export const PrepareData: HandlerType = props => {
    const {
        getState,
        parameter: { url },
    } = props;

    props.recommendation = {
        type: "other",
        ...generateGeneralPrepare(getState(), { url }),
    };
};

export const CallPrepareTrack: HandlerType = ({ dispatch, recommendation }) => {
    dispatch(prepareTrack({ prepareTrackData: recommendation }));
};

export const chain = [ValidateContext, PrepareData, CallPrepareTrack];

const prepareOther = createHandlerChainRunner(chain, "PrepareOther");
export default prepareOther;
